<div *ngIf="context === 'option'" class="gear-bucket-picker">
  <div fwButtonLike test-id="bucket-option-data" (click)="setContext('data')" class="gear-bucket-option">
    <mat-icon class="lg">plumbing</mat-icon>
    <strong>{{ 'gearVersionSelector.contextOptions.utility.label' | translate }}</strong>
    <p>{{ 'gearVersionSelector.contextOptions.utility.description' | translate }}</p>
  </div>
  <div fwButtonLike test-id="bucket-option-analysis" (click)="setContext('analysis')" class="gear-bucket-option">
    <mat-icon class="lg">pie_chart</mat-icon>
    <strong>{{ 'gearVersionSelector.contextOptions.analysis.label' | translate }}</strong>
    <p>{{ 'gearVersionSelector.contextOptions.analysis.description' | translate }}</p>
  </div>
</div>

<form *ngIf="context !== 'option'" [formGroup]="form" class="select-gear-form">
  <ng-container *ngIf="filteredGearOptions$ | async as gearOptions">
    <ng-container *ngIf="!isLoading">
      <div [ngSwitch]="context" class="instructions">
        <strong *ngSwitchCase="'data'">{{ 'gearVersionSelector.selectGear.utility' | translate }}</strong>
        <strong *ngSwitchCase="'analysis'">{{ 'gearVersionSelector.selectGear.analysis' | translate }}</strong>
      </div>
      <div class="form-fields">
        <mat-form-field appearance="outline" class="gear-name solid-background">
          <input
            type="text"
            matInput
            formControlName="label"
            test-id="gear-name-filter"
            [placeholder]="'gearVersionSelector.selectGear.gearNameTypeahead' | translate"
            [matAutocomplete]="gearNameAutocomplete">
          <button
            *ngIf="(!isQuerying && gearOptions.length < 1) || (form.get('name').value && form.get('name').enabled); else dropdownIndicator"
            test-id="gear-name-filter-clear"
            matSuffix
            mat-icon-button
            (click)="clearSelectedGear()"
            matTooltip="{{ 'common.labels.clearTooltip' | translate }}"
            matTooltipPosition="right">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template #dropdownIndicator>
            <mat-icon matSuffix matTooltipPosition="right" class="match-select-icon">arrow_drop_down</mat-icon>
          </ng-template>
          <mat-autocomplete
            #gearNameAutocomplete="matAutocomplete"
            test-id="select-gear-name"
            fwOverlayPanelClass
            (optionSelected)="selectGearOption($event)"
            class="no-max-width">
            <ng-container *ngFor="let suite of gearOptions">
              <ng-container *ngIf="!suite.label">
                <mat-option *ngFor="let option of suite.options" class="match-select" [value]="option.value">{{ option.label }}</mat-option>
              </ng-container>
              <mat-optgroup *ngIf="suite.label" [label]="suite.label" class="mat-select-like">
                <mat-option *ngFor="let option of suite.options" class="match-select" [value]="option.value">{{ option.label }}</mat-option>
              </mat-optgroup>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="gear-version solid-background"
          matTooltip="{{ 'gearVersionSelector.selectGear.versionTooltip' | translate }}"
          matTooltipPosition="left" [matTooltipDisabled]="!showVersionTooltip()">
          <mat-select formControlName="id" test-id="select-gear-version">
            <mat-option *ngFor="let option of versionOptions" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="!isQuerying && gearOptions.length > 0">
        <em *ngIf="selectedGearId" class="gear-description">{{ gears[selectedGearId]?.gear.description }}</em>
        <div *ngIf="billingLabels[gears[selectedGearId]?.gear.name] as billedLab" class="billed-lab">
          {{ 'gearVersionSelector.billedLab' | translate | interpolate:billedLab }}
        </div>
      </ng-container>
      <p *ngIf="!isQuerying && gearOptions.length < 1" class="no-gear-options">{{ 'gearVersionSelector.selectGear.noGearOptions' | translate }}</p>
    </ng-container>
  </ng-container>
  <fw-progress-spinner *ngIf="isLoading || isQuerying" mode="indeterminate" size="medium"></fw-progress-spinner>
</form>

